var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.41779C17.3377 2.71179 16.626 2.90979 15.879 2.99904C16.6418 2.54229 17.2275 1.81854 17.5028 0.956035C16.7895 1.37904 15.999 1.68654 15.1575 1.85229C14.4847 1.13454 13.524 0.686035 12.462 0.686035C10.0777 0.686035 8.32575 2.91054 8.86425 5.21979C5.796 5.06604 3.075 3.59604 1.25325 1.36179C0.28575 3.02154 0.7515 5.19278 2.3955 6.29228C1.791 6.27278 1.221 6.10704 0.72375 5.83029C0.68325 7.54104 1.9095 9.14153 3.6855 9.49778C3.16575 9.63878 2.5965 9.67179 2.0175 9.56079C2.487 11.0278 3.8505 12.095 5.4675 12.125C3.915 13.3423 1.959 13.886 0 13.655C1.63425 14.7028 3.576 15.314 5.661 15.314C12.5175 15.314 16.3912 9.52328 16.1572 4.32954C16.8787 3.80828 17.505 3.15804 18 2.41779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.362842ee2bf45a127e4a45f59ac4b39b.svg";
export { ForwardRef as ReactComponent };